import { FC } from "react";

type SwiperArrowRightProps = {
  fill?: string;
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const SwiperArrowLeft: FC<SwiperArrowRightProps> = ({
  fill = "#EB8367",
  width = 17,
  height = 17,
  ...rest
}) => <svg
  width={width}
  height={height}
  viewBox="0 0 17 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3898 8.43362C16.3898 8.69885 16.2844 8.95322 16.0969 9.14076C15.9093 9.32831 15.6549 9.43367 15.3897 9.43367L3.80241 9.43367L8.09598 13.7272C8.27263 13.9168 8.3688 14.1676 8.36423 14.4266C8.35966 14.6857 8.2547 14.9329 8.07148 15.1161C7.88825 15.2994 7.64105 15.4043 7.38197 15.4089C7.12289 15.4135 6.87215 15.3173 6.68257 15.1407L0.68224 9.14033C0.494962 8.95281 0.389771 8.69863 0.389771 8.43362C0.389771 8.1686 0.494962 7.91442 0.68224 7.72691L6.68257 1.72658C6.87215 1.54993 7.12289 1.45376 7.38197 1.45834C7.64105 1.46291 7.88825 1.56786 8.07148 1.75109C8.2547 1.93432 8.35966 2.18151 8.36423 2.44059C8.3688 2.69968 8.27263 2.95042 8.09598 3.14L3.80241 7.43356L15.3897 7.43356C15.6549 7.43356 15.9093 7.53893 16.0969 7.72647C16.2844 7.91402 16.3898 8.16839 16.3898 8.43362Z"
      fill={fill}
    />
  </svg>